import Vue from 'vue';
import VueRouter from 'vue-router';
import HomePage from './components/home.vue';
import ContactPage from './components/contact.vue';
import BlogPage from './components/blogs.vue';
import SingleBlog from './components/singleBlog.vue';
import notFound from './components/notFound.vue';
import SingleProject from './components/singleProject';
import ProjectPage from './components/projects.vue'
import blogTag from './components/blogTag.vue';

Vue.use(VueRouter);

const routes = [
    {
        path: '/',
        name: 'Home',
        component: HomePage
    },
    {
        path: '/contact',
        name: 'Contact',
        component: ContactPage
    },
    {
        path: '/blogs',
        name: 'Blog',
        component: BlogPage
    },
    {
        path: '/blogs/:id',
        name: 'SingleBlog',
        component: SingleBlog,
        props: true,
    },
    {
        path: '/projects',
        name: 'Projects',
        component: ProjectPage
    },
    {
        path: '/projects/:id',
        name: 'SingleProject',
        component: SingleProject,
        props: true
    },
    {
        path: '/blogsByTag/:id',
        name: 'blogTag',
        component: blogTag,
        props: true
    },
    {
        path: "/:notFound",
        component: notFound
    },
]

const router = new VueRouter({
    mode: 'history',
    routes
});

export default router;